import React, { useState, useEffect } from "react";
import { Modal, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import config from "../../../../config/config";

const VideoOrdering = ({ isOpen, onClose, videos, onOrderUpdated }) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDatalist([...videos]); // fresh copy every time modal is opened
    }
  }, [isOpen]);

  useEffect(() => {
    console.log("Modal open:", isOpen);
    console.log("Videos received:", videos);
  }, [isOpen]);

  const handleOrderUpdate = async () => {
    try {
      setLoading(true);

      const orderPayload = datalist.map((item, index) => ({
        _id: item._id,
        sort_order: index + 1,
      }));

      const { data } = await axios.post(
        `${config.api_url}media/videos/reorder`,
        { order: orderPayload }
      );

      notification.success({
        message: "Video order updated successfully!",
      });

      if (onOrderUpdated) {
        onOrderUpdated(data);
      }

      onClose();
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Error updating video order",
      });
    } finally {
      setLoading(false);
    }
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    const items = Array.from(datalist);
    const [removed] = items.splice(source.index, 1);
    items.splice(destination.index, 0, removed);
    setDatalist(items);
  };

  return (
    <Modal
      title="Reorder Videos"
      visible={isOpen}
      onOk={handleOrderUpdate}
      onCancel={onClose}
      okText="Update"
      confirmLoading={loading}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="video-droppable">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ maxHeight: 400, overflowY: "auto" }}
            >
              {datalist.map((video, index) => (
                <Draggable
                  key={video._id}
                  draggableId={video._id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={{
                        ...provided.draggableProps.style,
                        padding: "10px",
                        marginBottom: "8px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        background: "#fff",
                        boxShadow: snapshot.isDragging
                          ? "0 0 .4rem #666"
                          : "none",
                      }}
                    >
                      {/* Title only */}
                      <span style={{ flex: 1 }}>{video.title}</span>

                      {/* Drag handle */}
                      <div
                        {...provided.dragHandleProps}
                        style={{ cursor: "grab" }}
                      >
                        ☰
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default VideoOrdering;
